import React from "react";
import VisoLabsIconPic from "./../../assets/images/VisoLabsIcon.png";

export default function VisoLabsIconButton(props) {
  return <img src={VisoLabsIconPic} alt="" />;
}
